<div class="meetings-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Meeting Hub</p>
      <h2>Meetings & Calendar</h2>
      <p class="subtitle">Schedule staff meetings, pick audio or video room type, and keep everyone aligned from one calendar view.</p>
    </div>
    <div class="header-actions">
      <button mat-stroked-button (click)="loadMeetings()">Refresh</button>
      <button mat-flat-button color="primary" (click)="openCreateDialog()">New Meeting</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <mat-tab-group [(selectedIndex)]="activeTab">
    <mat-tab label="Hub">
      <div class="hub-grid">
        <section class="hero-card">
          <div class="hero-top">
            <div>
              <span>Today</span>
              <strong>{{ todayMeetings.length }}</strong>
            </div>
            <div>
              <span>Upcoming</span>
              <strong>{{ upcomingMeetings.length }}</strong>
            </div>
            <div>
              <span>Live Now</span>
              <strong>{{ ongoingMeetings.length }}</strong>
            </div>
          </div>
          <div class="hero-note">Invited staff will receive in-app notifications and see the meeting on their own calendar list.</div>
        </section>

        <section class="panel">
          <div class="panel-head">
            <h3>Ongoing Meetings</h3>
            <span>Join live now</span>
          </div>
          <div class="meeting-row" *ngFor="let meeting of ongoingMeetings" [ngClass]="toneClass(meeting)" (click)="openMeeting(meeting)">
            <div>
              <strong>{{ meeting.title }}</strong>
              <small>{{ meeting.startTime | date:'shortTime' }} - {{ meeting.endTime | date:'shortTime' }} · {{ meeting.roomType }} · {{ meeting.attendeeCount }} attendee(s)</small>
            </div>
            <div class="row-actions">
              <span class="status-pill live">Live</span>
              <button mat-flat-button color="primary" type="button" (click)="joinMeeting(meeting, $event)">Join</button>
            </div>
          </div>
          <div class="empty-state" *ngIf="!ongoingMeetings.length">No meeting is currently live.</div>
        </section>

        <section class="panel">
          <div class="panel-head">
            <h3>Upcoming Meetings</h3>
            <span>{{ monthLabel() }}</span>
          </div>
          <div class="meeting-row" *ngFor="let meeting of upcomingMeetings" [ngClass]="toneClass(meeting)" (click)="openMeeting(meeting)">
            <div>
              <strong>{{ meeting.title }}</strong>
              <small>{{ meeting.startTime | date:'medium' }} · {{ meeting.roomType }} · {{ meeting.attendeeCount }} attendee(s)</small>
            </div>
            <div class="row-actions">
              <span class="status-pill">{{ meeting.status }}</span>
              <button mat-stroked-button type="button" (click)="joinMeeting(meeting, $event)">Join</button>
            </div>
          </div>
          <div class="empty-state" *ngIf="!upcomingMeetings.length">No upcoming meetings in this month.</div>
        </section>

        <section class="panel">
          <div class="panel-head">
            <h3>Completed / Past</h3>
            <span>Recent history</span>
          </div>
          <div class="meeting-row ghost" *ngFor="let meeting of completedMeetings" (click)="openMeeting(meeting)">
            <div>
              <strong>{{ meeting.title }}</strong>
              <small>{{ meeting.startTime | date:'mediumDate' }} · {{ meeting.roomType }}</small>
            </div>
            <span class="status-pill subdued">{{ meeting.status }}</span>
          </div>
          <div class="empty-state" *ngIf="!completedMeetings.length">No completed meetings yet.</div>
        </section>
      </div>
    </mat-tab>

    <mat-tab label="Calendar">
      <div class="calendar-shell">
        <div class="calendar-toolbar">
          <button mat-icon-button (click)="previousMonth()"><mat-icon>chevron_left</mat-icon></button>
          <h3>{{ monthLabel() }}</h3>
          <button mat-icon-button (click)="nextMonth()"><mat-icon>chevron_right</mat-icon></button>
        </div>

        <div class="calendar-grid">
          <div class="weekday" *ngFor="let day of calendarWeeks[0]">{{ dayLabel(day.date) }}</div>

          <ng-container *ngFor="let week of calendarWeeks">
            <div
              class="calendar-cell"
              *ngFor="let day of week"
              [class.outside]="!day.inMonth"
              [class.active]="isSelectedDay(day.date)"
              (click)="selectDay(day.date)"
            >
              <span class="day-number">{{ day.date.getDate() }}</span>
              <div class="day-meetings">
                <button type="button" class="day-chip" *ngFor="let meeting of day.meetings | slice:0:2" [ngClass]="toneClass(meeting)" (click)="openMeeting(meeting); $event.stopPropagation()">
                  {{ meeting.title }}
                </button>
                <small *ngIf="day.meetings.length > 2">+{{ day.meetings.length - 2 }} more</small>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="selected-day-panel">
          <div class="panel-head">
            <h3>{{ selectedDay | date:'fullDate' }}</h3>
            <span>{{ selectedDayMeetings.length }} meeting(s)</span>
          </div>
          <div class="meeting-row" *ngFor="let meeting of selectedDayMeetings" [ngClass]="toneClass(meeting)" (click)="openMeeting(meeting)">
            <div>
              <strong>{{ meeting.title }}</strong>
              <small>{{ meeting.startTime | date:'shortTime' }} - {{ meeting.endTime | date:'shortTime' }} · {{ meeting.roomName }}</small>
            </div>
            <div class="row-actions">
              <span class="status-pill" [class.live]="isLiveMeeting(meeting)">
                {{ isLiveMeeting(meeting) ? 'Live' : meeting.roomType }}
              </span>
              <button mat-stroked-button type="button" (click)="joinMeeting(meeting, $event)">Join</button>
            </div>
          </div>
          <div class="empty-state" *ngIf="!selectedDayMeetings.length">No meetings on this date.</div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
